import { ICatalogHeaderMap } from '../models/catalog';

export const CATALOG_FIXED_TEMPLATE_HEADERS: string[] = [
  'Item Number',
  'Brand Name',
  'Product Name',
  'Product Description',
  'Routine Information',
  'Product Photo (PNG download link)',
  'Product Link',
  'Categories',
  'Product Add to Cart Code',
  'Weight',
  'Price',
  'Acne',
  'Wrinkles',
  'Redness',
  'Eyebag',
  'Dark Circle',
  'Oiliness'
];

/**
 * Monta os headers do template do catálogo: colunas fixas de produto seguidas
 * de uma coluna "Question N Answer" por questão ativa, na ordem recebida.
 */
export function buildTemplateHeaders(questionCount: number): string[] {
  const questionHeaders = Array.from({ length: questionCount }, (_, index) => `Question ${index + 1} Answer`);
  return [...CATALOG_FIXED_TEMPLATE_HEADERS, ...questionHeaders];
}

/**
 * Gera os aliases aceitos (import) para a coluna de resposta da questão de posição `index` (0-based).
 */
export function buildQuestionHeaderAliases(index: number): string[] {
  const position = index + 1;
  return [
    `Question ${position} Answer`,
    `Resposta Pergunta ${position}`,
    `Resposta da Pergunta ${position}`,
    `Pergunta ${position}`
  ];
}

export const CATALOG_HEADER_ALIASES: Record<keyof ICatalogHeaderMap, string[]> = {
  itemNumber: ['Item Number', 'Numero do Item', 'Número do Item', 'Item'],
  brandName: ['Brand Name', 'Nome da Marca', 'Marca'],
  productName: ['Product Name', 'Nome do Produto'],
  productDescription: ['Product Description', 'Descricao do Produto', 'Descrição do Produto'],
  routineInformation: ['Routine Information', 'Informacoes sobre rotina', 'Informações sobre rotina', 'Rotina'],
  productPhotoLink: [
    'Product Photo (PNG download link)',
    'Foto do Produto (link para download PNG)',
    'Link da Foto do Produto',
    'Foto do Produto'
  ],
  productLink: ['Product Link', 'Link do Produto'],
  categories: ['Categories', 'Categoria', 'Categorias'],
  productAddToCartCode: [
    'Product Add to Cart Code',
    'Codigo para adicionar ao carrinho',
    'Código para adicionar ao carrinho'
  ],
  weight: ['Weight', 'Peso', 'Product Weight', 'Recommendation Weight'],
  price: ['Price', 'Preço', 'Preco', 'Valor'],
  acne: ['Acne'],
  wrinkles: ['Wrinkles', 'Rugas'],
  redness: ['Redness', 'Vermelhidao', 'Vermelhidão'],
  eyebag: ['Eyebag', 'Eyebags', 'Bolsas nos olhos', 'Bolsas sob os olhos'],
  darkCircle: ['Dark Circle', 'Dark Circles', 'Olheira', 'Olheiras'],
  oiliness: ['Oiliness', 'Oleosidade']
};
